/** @jsxImportSource @emotion/react */
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const StyledMuiBtnBlue = styled(Button)(() => ({
  transform: 'scale(0.75)',
  transformOrigin: 'right top',
}))

export default StyledMuiBtnBlue;